import { DocumentReference, Timestamp } from '@angular/fire/firestore';

export class ShopArticle {

  article: DocumentReference;

  stock: number;

  stockDifference?: number;

  refilled: Timestamp = Timestamp.now();
}
